<template>
  <div>
    <div v-show="!isLoaded">
      <spin-loader />
    </div>
    <div v-show="isLoaded">
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          md="12"
          lg="10"
        >
          <div
            v-if="hasPermissionToUpdate"
          >
            <b-row
              v-if="isViewMode"
            >
              <b-col
                class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
              >
                <b-dropdown
                  id="actions"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  right
                  class="dropdown-icon-wrapper"
                >
                  <template #button-content>
                    <feather-icon
                      icon="SettingsIcon"
                      size="16"
                      class="align-middle"
                    />
                  </template>

                  <b-dropdown-item
                    id="bnt-edit"
                    :disabled="!hasPermissionToUpdate"
                    @click="enableEdition()"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Editar</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    :disabled="!hasPermissionToDelete"
                    @click="showConfirmOrCancelDelete(transportId)"
                  >
                    <svg-icon
                      type="mdi"
                      size="16"
                      :path="mdiTrashCanOutline"
                    />
                    <span class="align-middle ml-50">Remover</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
          </div>

          <validation-observer
            #default="{ handleSubmit, invalid }"
            ref="refFormObserver"
          >
            <b-form
              class="mt-1"
              @submit.prevent="handleSubmit(onSubmit)"
            >

              <participant-edit-card
                v-model="transport"
                :required-fields="requiredFieldsParticipant"
                :readonly="isViewMode"
              />

              <address-edit-card
                :address="transport"
                :is-view-mode="isViewMode"
                :required-fields="requiredFieldsAddress"
                :enabled-fields="enabledFieldsAddress"
              />

              <contact-card
                v-if="!isCreateMode"
                :carrier="transportId"
                :readonly="isViewMode"
              />

              <b-card
                no-body
                class="card-user-style"
              >
                <b-card-title class="text-black mt-2 ml-2 mb-0">
                  <svg-icon
                    type="mdi"
                    :path="mdiBankCircleOutline"
                  />
                  <span
                    class="d-inline font-weight-bolder ml-50"
                  >
                    Dados para Pagamento
                  </span>
                </b-card-title>
                <hr>
                <b-card-body class="pt-1">
                  <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col
                          cols="12"
                          md="6"
                        >
                          <validation-provider
                            #default="validationContext"
                            name="pix_key"
                          >
                            <b-form-group
                              label="Chave PIX"
                              label-for="pix_key"
                            >
                              <b-form-input
                                id="pix_key"
                                v-model="transport.pix_key"
                                :state="isViewMode ? null : getValidationState(validationContext)"
                                :placeholder="isViewMode ? '' : 'Chave PIX'"
                                :readonly="isViewMode"
                              />
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                        >
                          <validation-provider
                            #default="validationContext"
                            name="account_owner"
                          >
                            <b-form-group
                              label="Titular da Conta"
                              label-for="account_owner"
                            >
                              <b-form-input
                                id="account_owner"
                                v-model="transport.account_owner"
                                :state="isViewMode ? null : getValidationState(validationContext)"
                                :placeholder="isViewMode ? '' : 'Titular da Conta'"
                                :readonly="isViewMode"
                              />
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          cols="12"
                          md="4"
                        >
                          <validation-provider
                            #default="validationContext"
                            name="bank_name"
                          >
                            <b-form-group
                              label="Banco"
                              label-for="bank_name"
                            >
                              <b-form-input
                                id="bank_name"
                                v-model="transport.bank_name"
                                :state="isViewMode ? null : getValidationState(validationContext)"
                                name="bank_name"
                                :placeholder="isViewMode ? '' : 'Banco'"
                                :readonly="isViewMode"
                              />
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col
                          cols="12"
                          md="4"
                        >
                          <validation-provider
                            name="bank_agency"
                          >
                            <b-form-group
                              label="Agência"
                              label-for="bank_agency"
                            >
                              <cleave
                                id="bank_agency"
                                v-model="transport.bank_agency"
                                name="bank_agency"
                                class="form-control"
                                :options="options.number"
                                :readonly="isViewMode"
                                :placeholder="isViewMode ? '' : 'Agência'"
                              />
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col
                          cols="12"
                          md="4"
                        >
                          <validation-provider
                            name="bank_account"
                          >
                            <b-form-group
                              label="Conta"
                              label-for="bank_account"
                            >
                              <cleave
                                id="bank_account"
                                v-model="transport.bank_account"
                                name="bank_account"
                                class="form-control"
                                :options="options.number"
                                :readonly="isViewMode"
                                :placeholder="isViewMode ? '' : 'Conta'"
                              />
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
              <b-row
                class="mt-2"
              >
                <b-col class="d-flex justify-content-end buttonsSaveCancel">
                  <b-button
                    v-if="!isViewMode"
                    id="btn-save"
                    type="submit"
                    variant="primary"
                    class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                    :disable="invalid"
                  >
                    Salvar
                  </b-button>
                  <b-button
                    id="itemCancelButton"
                    variant="outline-primary"
                    class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                    :to=" { name: 'transport' } "
                  >
                    Voltar
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BButton,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardBody,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'

import {
  mdiBankCircleOutline,
  mdiPlusCircleOutline,
  mdiTrashCanOutline,
} from '@mdi/js'

import SvgIcon from '@jamescoyle/vue-icon'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import syslic from '@/syslic'
import router from '@/router'
import SyncLoad from '@/components/utils/syncLoad'
import AddressEditCard from '@/components/address/AddressEditCard.vue'
import ParticipantEditCard from '@/components/participant/ParticipantEditCard.vue'
import ContactCard from '@/components/contact/ContactCard.vue'
import SpinLoader from '@/components/spinloader/SpinLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BCard,
    BCardBody,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    ParticipantEditCard,
    AddressEditCard,
    BDropdown,
    BDropdownItem,
    SpinLoader,
    SvgIcon,
    Cleave,
    ContactCard,
  },
  directives: {
    Ripple,
  },
  data() {
    const requiredFieldsAddress = [
    ]

    const enabledFieldsAddress = [
      'zip_code',
      'address',
      'number',
      'complement',
      'neighborhood',
      'state',
      'city',
      'country',
    ]

    const requiredFieldsParticipant = [
      'name',
    ]

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(this.transport)

    let isViewMode = true
    let isCreateMode = false

    if (router.currentRoute.path.match(/.*\/edit\/.*/)
        || router.currentRoute.path.match(/.*\/create/)) {
      isViewMode = false
    }

    if (router.currentRoute.path.match(/.*\/create/)) {
      isCreateMode = true
    }

    const transport = {
      id: '',
      address: '',
      address_type: '',
      address_type_set: '',
      neighborhood: '',
      neighborhood_type: '',
      neighborhood_type_set: '',
      complement: '',
      number: '',
      city: '',
      city_set: '',
      state: '',
      state_set: '',
      country: 1,
      country_set: {
        id: 1,
        name: 'Brasil',
        code: '1058',
      },
      zip_code: '',
      pix_key: '',
      account_owner: '',
      bank_name: '',
      bank_agency: '',
      bank_account: '',
    }

    const isLoaded = false

    const syncLoad = new SyncLoad()
    syncLoad.addTrigger('transport')

    syncLoad.onReady(() => {
      this.isLoaded = true
    })

    return {
      isViewMode,
      isCreateMode,
      refFormObserver,
      getValidationState,
      text_error: '',
      transport,
      requiredFieldsAddress,
      enabledFieldsAddress,
      requiredFieldsParticipant,
      transportId: null,
      isLoaded,
      options: {
        price: {
          numeral: true,
          numeralDecimalScale: 2,
          numeralDecimalMark: ',',
          delimiter: '.',
        },
        number: {
          numeral: true,
          numeralDecimalScale: 0,
          numeralPositiveOnly: true,
          delimiter: '',
        },
      },
      syncLoad,
    }
  },
  computed: {
    hasPermissionToUpdate() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.transport.can_edit
    },
    hasPermissionToDelete() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.transport.can_delete
    },
  },
  created() {
    const idToUpdate = router.currentRoute.params.id
    this.transportId = router.currentRoute.params.id
    if (idToUpdate !== undefined) {
      syslic
        .transport
        .fetchTransport(router.currentRoute.params.id)
        .then(response => {
          this.transport = response.data
          this.syncLoad.ready('transport')
        })
        .catch(err => {
          if (err.status === 404) {
            router.push({ name: 'error-404' })
          }
          this.syncLoad.ready('transport')
        })
    } else {
      this.syncLoad.ready('transport')
    }
  },
  methods: {
    adjustDecimalPlaces(field, places) {
      const decimalReference = 10 * places
      const num = this.transport[field]

      if (num !== '') {
        this.transport[field] = ((num * decimalReference) / decimalReference).toFixed(places)
      }
    },
    createTransport() {
      syslic
        .transport
        .addTransport(this.transport)
        .then(response => {
          this.transportId = response.data.id
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Transportadora adicionada com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.disableEdition()
        })
        .catch(error => {
          let textError = 'Não foi possível adicionar a transportadora, por favor entre em contato com o administrador do sistema.'

          if (error.data.includes('duplicate key value violates unique constraint')) {
            textError = 'Já existe uma transportadora cadastrada com este nome ou CNPJ.'
          } else if (error.data.includes('is not valid cnpj')) {
            textError = 'O CNPJ informado não é válido. Por favor informe um CNPJ válido para cadastrar uma transportadora.'
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao adicionar transportadora.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    updateTransport() {
      syslic
        .transport
        .updateTransport(this.transport.id, this.transport)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Transportadora atualizada com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.disableEdition()
        })
        .catch(error => {
          let textError = 'Não foi possível atualizar a transportadora, por favor entre em contato com o administrador do sistema.'

          if (error.data.includes('duplicate key value violates unique constraint')) {
            textError = 'Já existe uma transportadora cadastrada com este nome ou CNPJ.'
          } else if (error.data.includes('is not valid cnpj')) {
            textError = 'O CNPJ informado não é válido. Por favor informe um CNPJ válido para cadastrar uma transportadora.'
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao atualizar a transportadora.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    onSubmit() {
      if (this.isCreateMode) {
        this.createTransport()
      } else {
        this.updateTransport()
      }
    },
    deleteTransport(id) {
      syslic
        .transport
        .deleteTransport(id)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Transportadora removida com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          router.push({ name: 'transport' })
        })
        .catch(error => {
          let textError = 'Não foi possível remover a transportadora do servidor, por favor entre em contato com o administrador do sistema.'

          if ('data' in error) {
            if (error.data.includes('they are referenced through protected foreign keys')) {
              textError = 'Esta transportadora é referenciado em alguma licitação, por este motivo não será possível exclui-lo.'
            }
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao remover transportadora.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    showConfirmOrCancelDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Você realmente quer remover essa transportadora?', {
          id: 'confirmation_box',
          title: 'Confirmar?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-primary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteTransport(item)
          }
        })
    },
    enableEdition() {
      router.push({ name: 'transport-edit' })
    },
    disableEdition() {
      if (this.isCreateMode) {
        router.push({ name: 'transport' })
      } else {
        router.push({
          name: 'transport-detail',
          params: {
            id: this.transportId,
          },
        })
          .catch(() => {})
      }

      this.isCreateMode = false
    },
  },
  setup() {
    const toast = useToast()
    const mask = {
      options: {
        cepDelimiter: {
          delimiters: ['-'],
          blocks: [5, 3],
          uppercase: true,
          required: true,
        },
        ieDelimiter: {
          delimiters: ['.', '.', '.'],
          blocks: [3, 3, 3, 3],
          uppercase: true,
        },
        cnpjDelimiter: {
          delimiters: ['.', '.', '/', '-'],
          blocks: [2, 3, 3, 4, 2],
          uppercase: true,
        },
      },
    }

    return {
      toast,
      mask,
      mdiBankCircleOutline,
      mdiPlusCircleOutline,
      mdiTrashCanOutline,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.disabledEdition .input-group-text{
  background-color: #efefef;
}

input::placeholder {
  color: #b9b9c3 !important;
}

.buttonsSaveCancel{
  .btn{
    min-width: 107px;
  }
}
</style>
